if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.useSuccessMessage = this.cart && this.cart.tagName.toLowerCase() !== 'cart-notification';
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    /**  Original function **/
    // onSubmitHandler(evt) {
    //   evt.preventDefault();
    //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    //   this.handleErrorMessage();
    //   this.submitButton.setAttribute('aria-disabled', true);
    //   this.submitButton.classList.add('loading');
    //   this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    //   const request = this.prepareRequestConfig();
    //   const formData = request.formData;

    //   fetch(`${routes.cart_add_url}`, request.config)
    //     .then((response) => response.json())
    //     .then((response) => {
    //       if (response.status && response.status != 422) {
    //         document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
    //           productVariantId: formData.get('id'),
    //           errors: response.errors || response.description,
    //           message: response.message
    //         }}));
    //         this.handleErrorMessage(response.description);
    //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    //         if (!soldOutMessage) return;
    //         this.submitButton.setAttribute('aria-disabled', true);
    //         this.submitButton.querySelector('span').classList.add('hidden');
    //         soldOutMessage.classList.remove('hidden');
    //         this.error = true;
    //         return;
    //       } else if (!this.cart) {
    //         window.location = window.routes.cart_url;
    //         return;
    //       }
    //       if(!this.error) {
    //         if(response.status != 422) {
    //           this.error = false;
    //           if(this.useSuccessMessage) {
    //             pushSuccessMessage(window.cartStrings.success);
    //           }
    //           this.completeAddToCartAction(response, formData.get('id'));
    //         } else {
    //           this.handleErrorMessage(response.description);
    //           this.handle422Error(formData.get('id'));
    //         }
    //       }
    //     })
    //     .catch((e) => {
    //       console.error(e);
    //     })
    //     .finally(() => {
    //       this.submitButton.classList.remove('loading');
    //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    //       this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    //     });
    // }

    /**  Modified function  for warranty product TU-JUL-122 **/
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const request = this.prepareRequestConfig();
      const formData = request.formData;

      const productVariantId = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity') || 1);

      /*
      * Check if warranty is selected
      */
      const warrantyCheckbox = document.querySelector(
        '.techup-warranty__checkbox:checked'
      );

      let requestConfig = request.config;

      /*
      * If warranty is selected:
      * Add main product + warranty in ONE request
      * using Shopify's native nested cart relationship.
      */
     let warrantyVariantId = null;
      // if (warrantyCheckbox) {
        

      //   warrantyVariantId = Number(
      //     warrantyCheckbox.dataset.variantId
      //   );

      //   if (!warrantyVariantId) {
      //     this.handleErrorMessage(
      //       'Unable to add the warranty. Please try again.'
      //     );

      //     this.submitButton.removeAttribute('aria-disabled');
      //     this.submitButton.classList.remove('loading');
      //     this.querySelector('.loading-overlay__spinner').classList.add('hidden');

      //     return;
      //   }

      //   const items = [
      //     {
      //       id: productVariantId,
      //       quantity: quantity,
      //       properties: {
      //         _extended_warranty: "true"
      //       }
      //     },
      //     {
      //       id: warrantyVariantId,
      //       quantity: quantity,
      //       parent_id: productVariantId
      //     }
      //   ];

      //   /*
      //   * Create JSON request for parent + child
      //   */
      //   requestConfig = fetchConfig('javascript');

      //   requestConfig.method = 'POST';

      //   requestConfig.headers['Content-Type'] = 'application/json';
      //   requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      //   requestConfig.body = JSON.stringify({
      //     items: items,

      //     /*
      //     * Keep the existing theme cart drawer functionality.
      //     * Shopify will return the required sections in the response.
      //     */
      //     sections: this.cart
      //       ? this.cart.getSectionsToRender().map(
      //           (section) => section.id
      //         )
      //       : [],

      //     sections_url: window.location.pathname
      //   });
      // }


      // let warrantyVariantId = null;

      // Always add the main product.
      const items = [
        {
          id: productVariantId,
          quantity: quantity
        }
      ];

      // Get selected complementary products with quantity > 1.
      const complementaryItems = [];

      document
        .querySelectorAll('complementary-products .complementary__item')
        .forEach((item) => {
          // debugger;
          const variantInput = item.querySelector('.complementary__item__info--variant input.complementary-variant-id');
          const quantityInput = item.querySelector('.quantity__input');

          if (!variantInput || !quantityInput) return;

          const variantId = Number(variantInput.value);
          const selectedQuantity = Number(quantityInput.value || 0);

          if (variantId && selectedQuantity > 0) {
            complementaryItems.push({
              id: variantId,
              quantity: selectedQuantity
            });
          }
        });

      // Add complementary products only when quantity > 1.
      items.push(...complementaryItems);

      console.log('complementaryItems');
      console.log(complementaryItems);
      console.log(items);

      // Add warranty if selected.
      if (warrantyCheckbox) {
        warrantyVariantId = Number(warrantyCheckbox.dataset.variantId);

        if (!warrantyVariantId) {
          this.handleErrorMessage(
            'Unable to add the warranty. Please try again.'
          );

          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          return;
        }

        // Mark the main product as having an extended warranty.
        items[0].properties = {
          _extended_warranty: 'true'
        };

        items.push({
          id: warrantyVariantId,
          quantity: quantity,
          parent_id: productVariantId
        });
      }

      // Send all applicable products in one request.
      requestConfig = fetchConfig('javascript');
      requestConfig.method = 'POST';
      requestConfig.headers['Content-Type'] = 'application/json';
      requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      requestConfig.body = JSON.stringify({
        items: items,
        sections: this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [],
        sections_url: window.location.pathname
      });

      /*
      * Add product / product + warranty to cart
      */
      fetch(`${routes.cart_add_url}`, requestConfig)
        .then((response) => response.json())
        // .then((response) => {

        //   /*
        //   * Error handling
        //   */
        //   if (response.status && response.status != 422) {

        //     document.dispatchEvent(
        //       new CustomEvent('afterAddCartError', {
        //         detail: {
        //           productVariantId: productVariantId,
        //           errors: response.errors || response.description,
        //           message: response.message
        //         }
        //       })
        //     );

        //     this.handleErrorMessage(response.description);

        //     const soldOutMessage =
        //       this.submitButton.querySelector('.sold-out-message');

        //     if (!soldOutMessage) return;

        //     this.submitButton.setAttribute(
        //       'aria-disabled',
        //       true
        //     );

        //     this.submitButton
        //       .querySelector('span')
        //       .classList.add('hidden');

        //     soldOutMessage.classList.remove('hidden');

        //     this.error = true;

        //     return;
        //   }

        //   /*
        //   * If there is no cart element,
        //   * redirect to cart page.
        //   */
        //   if (!this.cart) {
        //     window.location = window.routes.cart_url;
        //     return;
        //   }

        //   /*
        //   * Successful Add to Cart
        //   */
        //   if (!this.error) {

        //     if (response.status != 422) {

        //       this.error = false;

        //       if (this.useSuccessMessage) {
        //         pushSuccessMessage(window.cartStrings.success);
        //       }

        //       /*
        //       * Use the EXISTING theme cart drawer/cart
        //       * notification update functionality.
        //       */
        //       this.completeAddToCartAction(
        //         response,
        //         productVariantId
        //       );

        //     } else {

        //       this.handleErrorMessage(
        //         response.description
        //       );

        //       this.handle422Error(
        //         productVariantId
        //       );
        //     }
        //   }
        // })
        .then(async (response) => {
           /* * ===================================================== * SHOPIFY ERROR * ===================================================== */ 
           if ( response.status || response.errors || response.description || response.message ) { 
            console.log( 'Shopify Add to Cart Error:', response ); 
            /* * ----------------------------------------------------- * Get the current cart * ----------------------------------------------------- */ 
            if (warrantyVariantId) {
               try {
                 const cartResponse = await fetch( '/cart.js', { 
                  method: 'GET', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
                 } ); const cart = await cartResponse.json(); 
                 /* * --------------------------------------------------- * Find the parent product * * _extended_warranty = true identifies the * parent product that has the warranty relationship. * --------------------------------------------------- */ 
                 const parentLine = cart.items.find( item => Number(item.variant_id) === productVariantId && item.properties && item.properties._extended_warranty === 'true' ); 
                 /* * --------------------------------------------------- * Find the warranty child * --------------------------------------------------- */ 
                 const childLine = cart.items.find( item => Number(item.variant_id) === warrantyVariantId );
                  /* * --------------------------------------------------- * Get actual parent quantity * * Shopify may have added only part of the requested * quantity because of inventory availability. * --------------------------------------------------- */ 
                  const parentQuantity = parentLine ? Number(parentLine.quantity) : 0; 
                  console.log( 'Parent quantity:', parentQuantity ); 
                  console.log( 'Child quantity before update:', childLine ? childLine.quantity : 0 ); 
                  /* * --------------------------------------------------- * Update child quantity to match parent * --------------------------------------------------- */
                   if (childLine) { await fetch( '/cart/change.js', {
                     method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, 
                     body: JSON.stringify({ id: childLine.key, quantity: parentQuantity }) } ); console.log( 'Warranty quantity updated to:', parentQuantity ); } 
                     /* * --------------------------------------------------- * If parent was not added, remove warranty completely * --------------------------------------------------- */ 
                     if ( parentQuantity === 0 && childLine ) { await fetch( '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                       body: JSON.stringify({ id: childLine.key, quantity: 0 }) } ); } } catch (cartError) { console.error( 'Unable to synchronize warranty quantity:', cartError ); } } 
                       /* * ----------------------------------------------------- * Show Shopify error message * ----------------------------------------------------- */ 
                       this.handleErrorMessage( response.description || response.message || 'Unable to add the product to cart.' ); 
                       /* * IMPORTANT: * Do not execute success/cart drawer flow. */ this.error = true;
                      if (response.status && response.status == 422) {
                                  this.handle422Error(formData.get('id'));
                                }
                        return;  }
                        /* * ===================================================== * SUCCESS * ===================================================== */ 
                        if (!this.cart) { window.location = window.routes.cart_url; return; } if (!this.error) { this.error = false; if (this.useSuccessMessage) { 
                          pushSuccessMessage( window.cartStrings.success ); } this.completeAddToCartAction( response, productVariantId ); } })
        .catch((e) => {

          console.error('Add to cart failed:', e);

          this.handleErrorMessage(
            'Unable to add the product to cart. Please try again.'
          );

          this.error = true;

        })
        .finally(() => {

          this.submitButton.classList.remove('loading');

          if (
            this.cart &&
            this.cart.classList.contains('is-empty')
          ) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          this.querySelector(
            '.loading-overlay__spinner'
          ).classList.add('hidden');

        });
    }

    /**  END TU-JUL-122 **/

    


    prepareRequestConfig(setZeroQuantity = false) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      if(setZeroQuantity) {
        formData.set('quantity', 0);
      }

      return {
        config: config,
        formData: formData
      };
    }

    // ORIGINAL FUNCTION
    // handle422Error(variantId) {
    //   const request = this.prepareRequestConfig(true);
     
    //   fetch(`${routes.cart_add_url}`, request.config)
    //     .then((response) => response.json())
    //     .then(response => {
    //       this.completeAddToCartAction(response, variantId);
    //     });
    // }

     handle422Error(variantId) {
      const sectionsToRender = this.cart.getSectionsToRender();

      // Get current cart data
      const cartRequest = fetch(`${routes.cart_url}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Cart request failed: ${response.status}`);
          }

          return response.json();
        });

      // Get fresh HTML for every cart section
      const sectionRequests = sectionsToRender.map((section) => {
        return fetch(
          `${window.location.pathname}?section_id=${encodeURIComponent(section.section || section.id)}`
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Section ${section.id} request failed: ${response.status}`
              );
            }

            return response.text();
          })
          .then((html) => ({
            id: section.id,
            html: html
          }));
      });

      Promise.all([
        cartRequest,
        Promise.all(sectionRequests)
      ])
        .then(([cartData, sectionResults]) => {

          // Build the same structure renderContents() expects
          cartData.sections = {};

          sectionResults.forEach((section) => {
            cartData.sections[section.id] = section.html;
          });

          console.log('Cart response after 422:', cartData);

          this.completeAddToCartAction(cartData, variantId,false);
        })
        .catch((error) => {
          console.error('Unable to refresh cart after 422:', error);
        });
    }

    completeAddToCartAction(response, variantId) {
      const quickAddDrawer = this.closest('quick-add-drawer');
      if (quickAddDrawer) {
        document.body.addEventListener('drawerClosed', () => {
          setTimeout(() => { this.cart.renderContents(response) });
        }, { once: true });
        quickAddDrawer.close();
      } else {
        this.cart.renderContents(response);
      }
      document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {
        productVariantId: variantId,
        source: 'product-form',
        cartData: response
      }}));
      
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        if(this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
